import * as THREE from 'three'
import * as ZapparThree from '@zappar/zappar-threejs'
import * as Passes from './passes'
import { FaceEffectComposer } from './faceEffectComposer'

export class FaceMaterial {
  composer: FaceEffectComposer

  private fadeEdgesPass: Passes.FadeEdgesPass

  public constructor(
    private camera: ZapparThree.Camera,
    private renderer: THREE.WebGLRenderer,
    private tracker: ZapparThree.FaceTracker,
    private group: ZapparThree.FaceAnchorGroup,
    private faceBufferGeometry: ZapparThree.FaceBufferGeometry
  ) {

    this.composer = new FaceEffectComposer(
      camera,
      renderer,
      tracker,
      faceBufferGeometry
    )
    this.fadeEdgesPass = new Passes.FadeEdgesPass()
    this.composer.addPass(this.fadeEdgesPass)
  }

  public get texture(): THREE.ShaderMaterial {
    return this.composer.material
  }


  public dispose() {
    this.composer.dispose()
  }

  public render() {
    this.composer.render()
  }
}
